{
    "ManageCustomRoles_Title": "Add Custom Role Template",
    "ManageCustomRoles_Role_Name": "Role Template Name",
    "ManageCustomRoles_Description": "Description",
    "ManageCustomRoles_Cancel": "Cancel",
    "ManageCustomRoles_Help": "Help",
    "ManageCustomRoles_Save": "Save",

    "NAME": "ManageCustomRoles"
}
